import { DisablePortalContext } from './disable-portal-context'

export const DisablePortalProvider = DisablePortalContext.Provider
